// extracted by mini-css-extract-plugin
export default {"HoverTitle":"HoverTitle_HoverTitle__0kqlU"};